import repository from './repository'

const resource = 'expenses'

export default {
  index (params) {
    return repository.get(resource, { params })
  },
  totalAmount (params) {
    return repository.get(`${resource}/total`, { params })
  },
  intervals (params) {
    return repository.get(`${resource}/intervals`, { params })
  },
  storeIntervals (params) {
    return repository.get(`${resource}/store-intervals`, { params })
  },
  store (data, params) {
    return repository.post(resource, data, { params })
  },
  update (id, data) {
    return repository.put(`${resource}/${id}`, data)
  },
  delete (id) {
    return repository.delete(`${resource}/${id}`)
  },
  verify (data) {
    return repository.post(`${resource}/verify`, data)
  },
}
